export const GET_COMMENTS_REQUEST = 'GET_COMMENTS_REQUEST';
export const GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS';
export const GET_COMMENTS_FAIL = 'GET_COMMENTS_FAIL';

export const GET_POST_COMMENTS_REQUEST = 'GET_POST_COMMENTS_REQUEST';
export const GET_POST_COMMENTS_SUCCESS = 'GET_POST_COMMENTS_SUCCESS';
export const GET_POST_COMMENTS_FAIL = 'GET_POST_COMMENTS_FAIL';

export const ADD_FAVORITE_COMMENT = 'ADD_FAVORITE_COMMENT';
export const REMOVE_FAVORITE_COMMENT = 'REMOVE_FAVORITE_COMMENT';
